module.exports = __webpack_public_path__ + "img/26-dodge-alt.9bb0c02e.png";